import { PrimaryButton } from "@digipost/dds-buttons-react";
import { Heading } from "@digipost/dds-heading-react";
import Infobox from "@digipost/dds-infobox-react";
import { FC, ReactNode, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

import { RegistrationStatus } from "../infrastructure/redux/org/org-actions";
import { ReduxState } from "../infrastructure/redux/state";
import Translated from "../infrastructure/Translated";
import { useRootPath } from "../infrastructure/useRootPath";

type Props = {
  documentTitle: string;
  criteria: ReactNode;
};

const Manuell: FC<Props> = ({ documentTitle, criteria }) => {
  const navigate = useNavigate();
  const rootPath = useRootPath();

  const registrationStatus = useSelector(
    (state: ReduxState) => state.org.registrationStatus,
  );
  const params = useSelector((state: ReduxState) => state.app.params);

  const erBehandlerFlytType1 =
    params.mode === "behandler" && params.integrationType !== "2";
  const erSigneringsFlyt = params.mode === "signering";

  useEffect(() => {
    document.title = documentTitle;
  }, [documentTitle]);

  return (
    <main>
      <div className="register-content-wrapper">
        <Heading level={1} size="large">
          {registrationStatus === RegistrationStatus.FAILED ? (
            <Translated textKey="register.org.manual.failed_header" />
          ) : (
            <Translated textKey="register.org.manual.failed_ingen" />
          )}
        </Heading>
      </div>

      <section className="register-content">
        <Heading level={2} size="small">
          <Translated textKey="register.org.insufficient_access.manual.heading" />
        </Heading>
        <p>
          <Translated
            allowHtml={true}
            textKey="register.org.insufficient_access.manual.info"
          />
        </p>
        <div className="action-button">
          <PrimaryButton
            onClick={() => {
              if (erSigneringsFlyt) {
                navigate(`${rootPath}/bedrift/manuell/skjema`);
              } else if (erBehandlerFlytType1) {
                navigate(`${rootPath}/bedrift/manuell/fullmakt`);
              } else {
                navigate(`${rootPath}/bedrift/manuell/avtalevilkaar`);
              }
            }}
            data-testid="to-manual-schema-button"
          >
            <Translated textKey="register.org.insufficient_access.manual.link" />
          </PrimaryButton>
        </div>
        <Infobox variant="info" className="processing-notice">
          <Translated textKey="register.org.insufficient_access.manual.time_warning" />
        </Infobox>
      </section>

      <section className="register-content-wrapper">
        <div className="register-content">
          <Heading level={2} size="small">
            <Translated textKey="register.org.insufficient_access.send_link.header" />
          </Heading>
          <p>{criteria}</p>
        </div>
      </section>
    </main>
  );
};

export default Manuell;
